<div class="xl:col-span-2 flex flex-col flex-auto bg-card shadow overflow-hidden">
    <div class="overflow-x-auto vh-70 border" id="variantsTableWrapper">
        <table class="w-full bg-transparent" mat-table matSort [dataSource]="variantsDataSource" #variantsTable>

            <ng-container matColumnDef="id">
                <th class="px-2 py-3 border w-4" mat-header-cell *matHeaderCellDef>
                    <span class="w-full" translate>
                        teacher.variant.list.number
                    </span>
                </th>
                <td class="px-2" mat-cell *matCellDef="let variant">
                    <span class="pr-6 whitespace-nowrap">
                        {{variant.id}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th class="px-2 py-3 border w-4" mat-header-cell *matHeaderCellDef>
                    <span class="w-full" translate>
                        teacher.variant.list.name
                    </span>
                </th>
                <td class="px-2" mat-cell *matCellDef="let variant">
                    <span class="pr-6 whitespace-nowrap">
                        {{variant.title}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th class="px-2 py-3 border w-4" mat-header-cell *matHeaderCellDef>
                    <span class="w-full" translate>
                        teacher.variant.list.status
                    </span>
                </th>
                <td class="px-2" mat-cell *matCellDef="let variant">
                    <span class="pr-6 whitespace-nowrap">
                        {{getStatusLabel(variant.status)}}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="count_slides">
                <th class="px-2 py-3 border" mat-header-cell *matHeaderCellDef>
                    <span class="w-full" translate>
                        teacher.variant.list.slides
                    </span>
                </th>
                <td class="px-2" mat-cell *matCellDef="let variant">
                    <span class="leading-relaxed whitespace-nowrap">{{ variant.count_slides }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th class="px-2 py-3 border max-w-26" mat-header-cell *matHeaderCellDef>
                    <span class="w-full">
                    </span>
                </th>
                <td class="px-2 max-w-26" mat-cell *matCellDef="let variant">
                    <div class="flex-display">
                        <i class="material-icons cursor-pointer">remove_red_eye</i>

                        <div class="flex flex-wrap items-center justify-start -mx-1 fit-content" *ngIf="!variant.is_viewed">
                            <div class="m-1 py-0.5 px-2.5 rounded-full font-medium whitespace-nowrap text-blue-800 bg-blue-100" translate>
                                teacher.variant.list.new
                            </div>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr class="whitespace-nowrap bg-gray-100" mat-header-row *matHeaderRowDef="variantsTableColumns;sticky:true">
            </tr>
            <tr class="order-row h-16 cursor-pointer" mat-row *matRowDef="let variant; columns: variantsTableColumns;" (click)="joinPreview(variant)"></tr>
        </table>
    </div>
</div>
